import { Component, DoCheck, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, ValidationErrors, Validators, FormControl, ValidatorFn, AbstractControl } from "@angular/forms";

import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { Constants } from 'src/app/util/Constants';
import { ProgressService } from 'src/app/service/ProgressService';
import { User } from 'src/app/model/user';
import { UserService } from 'src/app/service/UserService';
import { PasswordValidator } from 'src/app/validator/PasswordValidator';
import { AppComponent } from 'src/app/app.component';
import { BaseComponent } from '../common/BaseComponent';
import { MenuService } from 'src/app/service/MenuService';
import { BpsEmailValidator } from 'src/app/validator/BpsEmailValidator';
import { environment } from 'src/environments/environment';
import { PrefLangValidator } from 'src/app/validator/PrefLangValidator';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styles: [`
  .password-container{
    position: relative;
  }
  .password-toggle{
   
    top: 30%;
    position: absolute;
    margin-bottom: 10%;
    text-align: right;
    cursor: pointer;
    background: none;
    border:none;
    text-decoration: underline; 
    color: blue;
  }
  .greyed-out {
      background-color: #ccc;
      /* Add any other styles to visually indicate the button is disabled */
    }
    @media print {
      body * {
        visibility: hidden;
      }
      .modal {
        position: absolute;
        left: 0;
        top: 0;
        margin: 10px;
        border: none;
        padding: 10px;
        flex-wrap: wrap;
        width:100%;
        height: auto !important; 
        visibility: visible;
        /**Remove scrollbar for printing.**/
        overflow: visible !important;
        page-break-after: avoid;
      }
      .not-print {
        visibility: hidden;
      }

      .modal-dialog {
        visibility: visible !important;
        /**Remove scrollbar for printing.**/
        overflow: visible !important;
        height: auto !important;
      }
    }
`]

})
export class RegisterComponent extends BaseComponent implements OnInit, DoCheck {

  @ViewChild('registerForm') registerFormElement: ElementRef;
  @ViewChild('pageMsg') pageMsgElement: ElementRef;
  @ViewChild('progressDialog') progressDialogElementRef!: ElementRef<HTMLDialogElement>;
  @ViewChild('termsButton', { static: true }) termsButton: ElementRef;
  @ViewChild('myDialog', { static: false }) myDialog: ElementRef;
  @ViewChild('preventOutsideTab') preventOutsideTab: ElementRef;
  @ViewChild('xCloseButton') xCloseButton: ElementRef;
  registerForm: FormGroup;
  restSub: Subscription;
  submitted: boolean = false;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  appErrorPrefix: string = "bss.api.error";
  user: User;
  isEdgeBrowser: boolean;
  notMatch: boolean;
  termsVisible: boolean;
  displayName: string;
  //displayNameControl: FormControl;
  pageMsgRendered: boolean;
  isFormValid: boolean;
  @ViewChild('confirmPassword') confirmPassword: ElementRef;

  constructor(
    injector: Injector,
    public rest: UserService,
    public fb: FormBuilder,
    public progressService: ProgressService
  ) {
    super(injector);

    this.submitted = false;
    this.notMatch = false;
    this.termsVisible = false;
    this.pageMsgRendered = false;
    this.displayName = '';
    this.isFormValid = false;
  }

  ngDoCheck() {
    this.isFormValid = this.registerForm.valid;
  }

  focusInput(field: string) {
    console.log("field: ", field);
    if (field === 'confirmPassword')
      this.confirmPassword.nativeElement.focus();
  }

  updateDisplayName(firstName: string, middleName: string, lastName: string) {
    if (middleName == null || middleName == '')
      this.displayName = `${firstName} ${lastName}`;
    else
      this.displayName = `${firstName} ${middleName} ${lastName}`;
    this.registerForm.controls['displayName'].setValue(this.displayName);
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  toggleShowConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  viewTerms() {
    this.termsVisible = true;
    //this.registerForm.get('agreeTerms').enable();
    //console.log("Clicked the viewTerms link");
  }

  focusFirstElement() {
    this.preventOutsideTab.nativeElement.focus();
  }

  ngOnInit(): void {

    if (!this.validateURL(window.location.href)) {
      console.log('Malformed URL encountered ' + window.location.href);
      this.router.navigate(['public/error']);
      return;
    }

    this.registerForm = new FormGroup({
      firstName: new FormControl(null, Validators.compose([Validators.required, Validators.pattern(Constants.EF_NAME)])),
      middleName: new FormControl(null, Validators.compose([Validators.pattern(Constants.EF_NAME)])),
      lastName: new FormControl(null, Validators.compose([Validators.required, Validators.pattern(Constants.EF_NAME)])),
      displayName: new FormControl(null, Validators.compose([Validators.pattern(Constants.EF_NAME)])),
      preferredLanguage: new FormControl('', Validators.compose([Validators.required, PrefLangValidator.checkValue])),
      //email: new FormControl(null, Validators.compose([Validators.required, Validators.email,Validators.pattern(Constants.EF_EMAIL), PasswordValidator.invalidEmail, BpsEmailValidator.restricted])),
      email: new FormControl(null, Validators.compose([Validators.required, PasswordValidator.invalidEmail, BpsEmailValidator.restricted])),
      confirmEmail: new FormControl(null, Validators.compose([Validators.required])),
      password: new FormControl(null,
        Validators.compose([
          Validators.required, PasswordValidator.startC, PasswordValidator.strongU, PasswordValidator.strongL, PasswordValidator.strongD, PasswordValidator.strongS, PasswordValidator.strongDS, PasswordValidator.strongR, Validators.minLength(12),Validators.maxLength(17)])),
      confirmPassword: new FormControl(null, Validators.compose([Validators.required, Validators.minLength(12), Validators.maxLength(17)])),
      agreeTerms: new FormControl({ value: false, disabled: false }, (Validators.requiredTrue))
    },
      {
        validators: [PasswordValidator.matchValidator('password', 'confirmPassword'), compareEmailValidator('email', 'confirmEmail')
          , PasswordValidator.passwordContainsFName('firstName', 'password'), PasswordValidator.passwordContainsLName('lastName', 'password'),
          PasswordValidator.newpasswordUserContainsEmail( 'password','email')
        ]
      });

    // Disable Terms & Conditions checkbox
    //this.registerForm.get('agreeTerms').disable();  
    console.log('In init() before Submission: ', this.registerForm);

    // If agreeTerms is true && form is valid, enable the Register button
    if (this.registerForm.get('agreeTerms').value && this.registerForm.valid)
      this.isFormValid = true;
  }
  ngAfterViewInit() {
    this.progressService.setDialog(this.progressDialogElementRef.nativeElement);
  }

  ngAfterViewChecked() {
    if (!this.pageMsgRendered && this.pageMsgElement !== undefined) {
      this.pageMsgElement.nativeElement.focus();
      this.pageMsgElement.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
      this.pageMsgRendered = true;
    }
  }
  // handleButtonClick() {
  //   // console.log("you use the enter to click the button")
  //   if (document.activeElement === this.termsButton.nativeElement && this.termsVisible === false) {
  //     // this.myDialog.nativeElement.showModal();
  //     // this.viewTerms();
  //   }
  // }
  handleButtonClick2() {
    // console.log("you have clicked the button");
    if (document.activeElement === this.termsButton.nativeElement) {
      // console.log("you have clicked the button and the focus is in the termsButton");
      this.myDialog.nativeElement.showModal();
      this.viewTerms();
    }
  }
  handleShiftTab(event: KeyboardEvent): void {
    const e = event.which || event.keyCode;
    if(event.shiftKey && e=== 9){
      event.preventDefault();
      this.xCloseButton.nativeElement.focus();
      // console.log("handleShiftTab");
    }
    }


  checkCheckbox(event: Event): void {

    const agreeTermsControl = this.registerForm.get('agreeTerms');

    if (this.termsVisible === false) {
      //agreeTermsControl.setValue(!agreeTermsControl.value);
      event.preventDefault();
      this.myDialog.nativeElement.showModal();
      this.viewTerms();
    }
    /*
    // Prompting the user to review the T&C
    //console.log("agreeTerms value: " + this.registerForm.get('agreeTerms').value);
    console.log("value.agreeTerms: " + this.registerForm.value.agreeTerms)
    
    if (this.registerForm.get('agreeTerms').value === true) {
      this.myDialog.nativeElement.showModal();
      this.viewTerms();
    }
    */
  }

  onDialogClose() {
    this.registerForm.get('agreeTerms').setValue(true);
    //this.viewTerms();
  }

  onCancel() {
    this.router.navigate(['/register']);
  }
  onPrint(): void {
    window.print();
  }
  onClose(): void {
    this.onDialogClose();
  }
  //onSave() {  
  onSubmit(): void {
    this.submitted = true;
    this.pageMsgRendered = false;

    console.log('In Submit() registerForm.valid:  ' + this.registerForm.valid);

    if (this.registerForm.valid && this.displayName !== null && this.displayName !== '' && this.registerForm.get('agreeTerms').value === true) {
      this.isSubmitting = true;

      let user = new User();
      user = this.registerForm.value;
      /*
      user.firstName = this.registerForm.get("firstname").value;
      user.middleName = this.registerForm.get("middlename").value;
      user.lastName = this.registerForm.get("lastname").value;
      user.displayName = this.registerForm.get("displayName").value;
      user.email = this.registerForm.get("email").value;
      user.confirmEmail = this.registerForm.get("confirmEmail").value;
      user.password = this.registerForm.get("password").value;
      user.confirmPassword = this.registerForm.get("confirmPassword").value;
      */

      // Set signin url for backend to include in email
      let resourceUrl: string = null;

      /*
      if (environment.env === "local") {
        this.route.queryParams
        .subscribe(params => {
          console.log(params);         
          resourceUrl = (params['resource_url'])?.trim() ?? '';
        });      
      }
      else
      { */
      resourceUrl = sessionStorage.getItem("resource_url");
      //}  
      if ((resourceUrl ?? false) && (resourceUrl !== "null")) {
        user.signinURL = decodeURIComponent(resourceUrl);

        //If signinURL is malformed
        const urlPattern = /^(https?):\/\/[^\s/$.?#<>].[^\s<>]*$/i;
        //console.log('SignIn URL ::' + user.signinURL);

        if (user.signinURL && !urlPattern.test(user.signinURL)) {
          console.log('Register: Invalid SignIn URL ::' + user.signinURL);
          this.router.navigate(['public/error']);
          return;
        }
      }
      else {
        var domain = window.location.origin;
        user.signinURL = domain + "/opsbpssecure/";
      }

      console.log('Form submitted:: User Values : ' + JSON.stringify(user));
      this.progressService.open();
      this.rest.register(user).subscribe((response) => {
        console.log("get-data:" + JSON.stringify(response));
        console.log("Register:: response.result: " + response.result);
        this.isSubmitting = false;
        if (response.result == 1) {
          this.appError = this.notMatch = true;
          this.appErrorMessage = this.appErrorPrefix + "." + response.error_code;
          console.log("Register:: appError: " + this.appError);
          console.log("Register:: appErrorMessage: " + this.appErrorMessage);
        }
        else if (response.result == 0) {
          this.appError = false;
          this.router.navigate(['public/register/success']);
        }
        else
          this.router.navigate(['public/error']);
      }, (error) => {
        this.processError(error);
      },
        () => {
          this.progressService.close();
        }

      );

    } else {
      console.log(this.registerForm.value);
      this.printFormValidationErrors();
    }

  }

  printFormValidationErrors() {
    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:15px;');
    let totalErrors = 0;

    Object.keys(this.registerForm.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.registerForm.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Control: ' + key + ', [' + keyError + '][', controlErrors[keyError] + ']');
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }

  onSignIn() {
    this.checkRedirectUrl();
  }

}

function compareEmailValidator(source: string, target: string): ValidatorFn {

  return (control: AbstractControl): { [key: string]: any; } | null => {
    const sourceCtrl = control.get(source);
    const targetCtrl = control.get(target);

    return sourceCtrl && targetCtrl && sourceCtrl.value !== targetCtrl.value ? { mismatchEmail: true } : null;
  };
}